import http from "./http-common";

class GarGroDataService {
  getGrosByUai(uai) {
    return http.get(`/garGro/uai/${uai}`);
  }

  addSequence(idSequence, idGro) {
    return http.get(`/garGro/addSequence/${idSequence}/${idGro}`);
  }

  removeSequence(idSequence, idGro) {
    return http.get(`/garGro/removeSequence/${idSequence}/${idGro}`);
  }
}

export default new GarGroDataService();
